<template>
  <div
    class="button-simple"
    :class="{
      'button-simple--primary': primary,
      'button-simple--light': light,
    }"
  >
    <div class="button-simple__inner">
      <button
        class="button"
        :class="{ 'overline mb-0': small }"
        :type="type"
        :disabled="disabled"
        @click="$emit('click')"
      >
        <slot></slot>
      </button>
      <div class="button-simple__arrow">
        <div class="button-simple__arrow-inner"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "buttonSimple",
  props: {
    primary: {
      type: Boolean,
      default: false,
    },
    light: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "button",
    },
  },
};
</script>

<style lang="scss">
@import "../stylesheets/colors";
.button-simple {
  margin-right: 20px;
  &__inner {
    cursor: pointer;
    background: transparent;
    border: none;
    color: rgba(#000, 1);
    transition: color 0.1s ease-in-out;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    position: relative;
    width: auto;
    button {
      position: relative;
      z-index: 2;
      border: none;
      background: none;
    }
    &:hover {
      .button-simple__arrow {
        width: 28px;
        transform: translateX(5px);
        &-inner {
          &::after {
            transform: rotate(35deg);
          }
          &::before {
            transform: rotate(-35deg);
          }
        }
      }
    }
  }
  &__arrow {
    display: block;
    position: absolute;
    right: -30px;
    width: 25px;
    height: 1px;
    background: #000;
    transition: width 0.1s cubic-bezier(0.075, 0.82, 0.165, 1),
      transform 0.2s cubic-bezier(0.075, 0.82, 0.165, 1);
    transform: translateX(0);
    &-inner {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      &::before,
      &::after {
        position: absolute;
        content: "";
        display: block;
        right: 0;
        margin-bottom: -1px;
        width: 8px;
        height: 1px;
        background: #000;
        transform-origin: 100% 50%;
        transition: transform 0.4s cubic-bezier(0.075, 0.82, 0.165, 1);
        will-change: transform;
        transform: rotate(0);
      }
    }
  }
  &--primary,
  &--light {
    .button-simple__inner {
      // padding: 10px;
      padding: 10px;
      padding-right: 0;
      color: #000;
      &::before {
        content: "";
        display: block;
        top: 0;
        left: 0;
        width: calc(100% + 20px);
        height: 100%;
        background: rgba($secondary, 1);
        position: absolute;
        z-index: 0;
        transition: background 0.1s cubic-bezier(0.075, 0.82, 0.165, 1),
          width 0.1s cubic-bezier(0.075, 0.82, 0.165, 1),
          left 0.1s cubic-bezier(0.075, 0.82, 0.165, 1);
        border: 1px solid rgba($secondary, 0);
      }
      &:hover {
        &::before {
          background: transparent;
          border-color: rgba($secondary, 1);
          left: 20px;
          width: calc(100% + 5px);
        }
      }
    }
  }
  &--light {
    .button-simple__inner {
      span {
        color: $light;
      }
      &::before {
        background: rgba($light, 0.2);
        border: 1px solid rgba($light, 1);
      }
      &:hover {
        &::before {
          // background: transparent;
          background: rgba($light, 0.2);
          border-color: rgba($light, 1);
          left: 20px;
          width: calc(100% + 5px);
        }
      }
    }
    .button-simple__arrow {
      background: $light;
      &-inner {
        &::before,
        &::after {
          background: $light;
        }
      }
    }
  }
}
</style>